export default __webpack_public_path__ + "static/media/faq.85c8752c.svg";